import React, { useState, useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import announcementApiServices from "../../services/announcementApiServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Announcement } from "../../types/announcement";

const AnnouncementBanner: React.FC = () => {
   const [announcements, setAnnouncements] = useState<Announcement[]>([]);
   const [currentIndex, setCurrentIndex] = useState<number>(0);
   const [dismissed, setDismissed] = useState<Record<string, boolean>>({});
   useEffect(() => {
      const fetchAnnouncements = async () => {
         try {
            const response = await announcementApiServices.getActiveAnnouncements();
            setAnnouncements(response.data.announcements || []);
         } catch (error) {
            console.error("Failed to fetch announcements:", error);
         }
      };

      fetchAnnouncements();

      // Rotate announcements every 10 seconds if there are multiple
      const rotationInterval = setInterval(() => {
         if (announcements.length > 1) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % announcements.length);
         }
      }, 10000);

      return () => clearInterval(rotationInterval);
   }, [announcements.length]);

   const handleDismiss = (id: string) => {
      setDismissed((prev) => ({ ...prev, [id]: true }));
   };

   // Filter out dismissed announcements
   const activeAnnouncements = announcements.filter((a) => !dismissed[a._id]);

   if (activeAnnouncements.length === 0) {
      return null;
   }

   const currentAnnouncement = activeAnnouncements[currentIndex % activeAnnouncements.length];

   return (
      <Alert
         variant={currentAnnouncement.severityLevel}
         className="announcement-banner m-0"
         style={{
            borderRadius: 0,
            position: "sticky",
            top: 0,
            padding: "10px 15px",
            marginBottom: "0 !important",
            textAlign: "center",
            zIndex: 1100,
         }}
      >
         <div style={{ paddingRight: "30px" }}>
            <span dangerouslySetInnerHTML={{ __html: currentAnnouncement.content }} />

            {activeAnnouncements.length > 1 && (
               <div className="mt-1">
                  <small>
                     Announcement {currentIndex + 1} of {activeAnnouncements.length}
                  </small>
               </div>
            )}
         </div>

         <Button
            variant="link"
            size="sm"
            onClick={() => handleDismiss(currentAnnouncement._id)}
            style={{
               position: "absolute",
               top: "5px",
               right: "5px",
               padding: "0.25rem",
               color: "inherit",
               opacity: "0.7",
            }}
         >
            <FontAwesomeIcon icon={faTimes} />
         </Button>
      </Alert>
   );
};

export default AnnouncementBanner;
